import React, { useContext } from "react";
import style from "./index.module.scss";
import { Modal } from "antd";
import { ModalProps } from "antd/es/modal";
import Tools from "./Tools";
import CommonTable from "../../../../../components/CommonTable";
import { ColumnProps } from "antd/lib/table/interface";
import {
    CopyActivityListItem,
    getGroupActivityListForCopy
} from "service/group";
import OverLengthColumn from "components/OverLengthColumn";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { CourseContext } from "../../../Store";
import moment from "moment";
import useSelection from "../../../../../utils/v2/useSelection";
import { copyGroupActivity } from "service/group";
import SubmitError from "components/SubmitError";
import {
    CopyListParams,
    PublishMap,
    PublishStatus
} from "../../../../../service/group";

interface CopyActivityModalProps extends ModalProps {
    onCancel: () => void; //关闭弹窗
    onOk: () => void; //保存
}

const Index = ({ onOk, onCancel, ...restProps }: CopyActivityModalProps) => {
    const { course } = useContext(CourseContext);
    const rowSelection = useSelection();

    const [getList, { loading, data }] = useRequestFn(
        getGroupActivityListForCopy
    );
    const [onSave, { loading: saveLoading }] = useRequestFn(copyGroupActivity);

    //查询
    const onSearch = async (params: CopyListParams) => {
        try {
            await getList(params);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //保存
    const handelSave = async () => {
        const params = {
            courseNo: course.courseNo,
            courseSeq: course.courseSeq,
            weektimeId: course.weekTimeId,
            ids: rowSelection.selected.join(",")
        };
        try {
            await onSave(params);
            await onOk();
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="复制失败" content={errorMessage(e)} />
            );
        }
    };

    const columns: ColumnProps<CopyActivityListItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            width: 60,
            render: (text, item, index) => index + 1
        },
        {
            title: "活动名称",
            dataIndex: "activityName",
            align: "center",
            render: text => <OverLengthColumn value={text} width={240} />
        },
        {
            title: "课程信息",
            dataIndex: "courseInfo",
            align: "center",
            render: text => <OverLengthColumn value={text} width={240} />
        },
        {
            title: "状态",
            dataIndex: "publishStatus",
            align: "center",
            render: (text: PublishStatus) => {
                return PublishMap[text];
            },
            filters: [
                { text: "待发布", value: "0" },
                { text: "已发布", value: "2" }
            ],
            filterMultiple: true,
            onFilter: (value, record) => record.publishStatus === value
        },
        {
            title: "活动任务数",
            dataIndex: "taskCount",
            align: "center"
        },
        {
            title: "创建时间",
            dataIndex: "createTime",
            align: "center",
            render: text => (
                <div>
                    {text ? moment(text).format("YY-MM-DD HH:mm:ss") : "--"}
                </div>
            )
        }
    ];

    return (
        <Modal
            title="复制活动"
            {...restProps}
            width={1200}
            maskClosable={false}
            onOk={handelSave}
            onCancel={onCancel}
            className={style.root}
            confirmLoading={saveLoading}>
            <Tools onSearch={onSearch} />

            <CommonTable
                columns={columns}
                dataSource={data || []}
                rowSelection={{
                    selectedRowKeys: rowSelection.selected as number[],
                    onChange: rowSelection.setSelected
                }}
                rowKey="id"
                pagination={false}
                loading={loading}
                scroll={{ y: 510 }}
                height="480px"
            />
        </Modal>
    );
};

export default Index;
